module.exports = __webpack_public_path__ + "img/logo-dornbirn-gfc.41283a21.jpeg";